export let DJANGO = false
export const BASENAME = "" // don't add '/' at end off BASENAME

export const API_KEY = process.env.REACT_APP_API_KEY

// In django, we define the default domain which the site is hosted on.
// If we are hosting react app as a standalone and not bundled with django, we can define the domain here.
// This is used in PublicArticle/HomePage.js to determine which landing page to show.
const defaultDomainElement = document.getElementById("default-site-domains")
const parsedDefaultDomain = defaultDomainElement
  ? JSON.parse(defaultDomainElement.textContent)
  : "localhost,"

export const DEFAULT_SITE_DOMAINS = parsedDefaultDomain.split(",")

// In django, we define the backend API server which the backend api server site is hosted on.
// This helps in having only one build for the react app and using it in multiple django sites.
const backendAPIServerElement = document.getElementById("backend-api-server")
export let API_SERVER = backendAPIServerElement
  ? JSON.parse(backendAPIServerElement.textContent)
  : process.env.REACT_APP_API_SERVER

export const changeApiUrl = (url) => {
  API_SERVER = url
  CONFIG.API_SERVER = url
  DJANGO = true
}

export const CONFIG = {
  API_SERVER: API_SERVER,
  API_KEY: API_KEY,
}

export const SITE_PRIMARY_COLOR =
  "linear-gradient(-135deg, #1de9b6 0%, #1dc4e9 100%)"
export const SITE_HEADER_TEXT_COLOR = "#ffffff"
export const SITE_HEADER_TEXT = ""
export const SITE_TITLE = "Welcome to"
